import {getBasicClientBookingsColumnsForBookingsTable} from '@modules/client/utils/clientBookingTable';
import {parsePrice} from '@utils/helpers';

export const ClientBookingsColumns = {
    ...getBasicClientBookingsColumnsForBookingsTable('booking'),
    'booking_type_name': {
        label: 'Type',
        sorting: true,
        header: {
            align: 'left',
        },
        content: {
            align: 'left',
        },
    },
    'price': {
        label: 'Price',
        sorting: row => parsePrice(row.price),
        header: {
            align: 'right',
        },
        content: {
            align: 'right',
        },
    },
    'event_invoice_status_name': {
        label: 'Invoice status',
        sorting: row => row.invoice_status,
        header: {
            align: 'left',
        },
        content: {
            align: 'left',
        },
    },
    'booking_creation_datetime': {
        label: 'Time',
        sorting: true,
        header: {
            align: 'center',
        },
        content: {
            align: 'center',
            singleLine: true,
        },
    },
    'actions': {
        label: 'Actions',
        header: {
            align: 'center',
        },
        content: {
            align: 'center',
        },
    },
};
